export const DEFAULT_MQTT_PORT = 1883;
export const DEFAULT_MQTTS_PORT = 8883;
export const MQTT_EVENT_TYPES = [
    {
        value: 'MQTT_HUB_META_DATA_FEED',
        label: 'MqttPublisher.HubMetaDataFeed',
        info: 'MqttPublisher.HubMetaDataFeedInfo',
    },
    {
        value: 'MQTT_SAMPLE_FEED',
        label: 'MqttPublisher.SampleFeed',
        info: 'MqttPublisher.SampleFeedInfo',
    },
] as const;

export type MqttPublisherAuthType = 'BASIC_AUTHENTICATION' | 'CERTIFICATE_BASED';

export const MQTT_PROTOCOL = 'MQTT' as const;
export const MQTTS_PROTOCOL = 'MQTTS' as const;
export type MqttPublisherProtocol = typeof MQTT_PROTOCOL | typeof MQTTS_PROTOCOL;

export interface MqttPublisherSensorUnits {
    radonUnit: string;
    tempUnit: string;
    pressureUnit: string;
    vocUnit: string;
}

// eslint-disable-next-line no-template-curly-in-string
export const DEFAULT_TOPIC_TEMPLATE = '${account_id}/${location_id}/${serial_number}';

/* eslint-disable no-template-curly-in-string */
export const TOPIC_TEMPLATE_VARIABLES = [
    '${account_id}',
    '${location_id}',
    '${serial_number}',
    '${message_type}',
] as const;
/* eslint-enable no-template-curly-in-string */

export interface MqttPublisherConfig {
    clientId: string;
    name: string;
    protocol: MqttPublisherProtocol;
    host: string;
    port: number;
    username: string | null;
    active: boolean;
    authType: MqttPublisherAuthType;
    subscribedToAll: boolean;
    eventTypes: string[];
    locations: string[];
    sensorUnits: MqttPublisherSensorUnits;
    topicTemplate?: string;
}

export interface MqttPublisherFormValues {
    name: string;
    protocol: MqttPublisherProtocol;
    host: string;
    port: number;
    authType: MqttPublisherAuthType;
    username?: string;
    password?: string;
    clientCertificate?: File;
    clientKey?: File;
    caCertificate?: File;
    active: boolean;
    subscribedToAll: boolean;
    eventTypes: string[];
    locations: string[];
    sensorUnits: MqttPublisherSensorUnits;
    topicTemplate?: string;
}
